/* Rising Sun FPV: newsletter pop-up (sections/rs-newsletter.liquid).
   - Opens once the visitor has been on the site for the set time (counted from their first page in this tab).
   - Closing snoozes it; signing up stops it for good and adds the discount code to the cart.
   - Waits while a drawer, menu or other modal is open, while the airlock intro runs, or while the visitor is typing.
   - Also waits while sessionStorage 'rsPopupHold' holds a time in the future (set by the ghost hunt alert).
   - Preview: ?rs_nl=1 opens it straight away. window.RSNewsletter.open() / .close() for testing. */
(function () {
  'use strict';

  var K_DONE = 'rsNlDone';
  var K_SNOOZE = 'rsNlSnoozeUntil';
  var K_START = 'rsNlStart';
  var K_SENT = 'rsNlSent';
  var DAY = 86400000;

  function storage(type) {
    try {
      var s = window[type];
      s.setItem('__rs_nl', '1');
      s.removeItem('__rs_nl');
      return s;
    } catch (e) {
      return null;
    }
  }
  var ls = storage('localStorage');
  var ss = storage('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, String(v)); } catch (e) {} }
  function del(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }

  function hasParam(name, value) {
    try { return new URLSearchParams(window.location.search).get(name) === value; } catch (e) { return false; }
  }

  function cleanUrl() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('customer_posted')) return;
      u.searchParams.delete('customer_posted');
      u.hash = '';
      window.history.replaceState(window.history.state, '', u.pathname + u.search);
    } catch (e) {}
  }

  function applyCode(code) {
    if (!code || !window.fetch) return;
    var base = (window.routes && window.routes.rootUrlWithoutSlash) || '';
    fetch(base + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      })
      .catch(function () {});
  }

  var timer = null;
  var api = { open: function () {}, close: function () {} };
  window.RSNewsletter = api;

  function init(root) {
    if (!root || root.getAttribute('data-rs-nl-ready')) return;
    root.setAttribute('data-rs-nl-ready', '1');

    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-rs-nl')) || {}; } catch (e) {}
    var delay = Math.max(0, Number(cfg.delay) || 30) * 1000;
    var snoozeDays = Number(cfg.snooze) || 14;

    var dialog = root.querySelector('.rs-nl__dialog');
    var form = root.querySelector('form');
    var successEl = root.querySelector('[data-rs-nl-success]');
    var errorsEl = root.querySelector('[data-rs-nl-errors]');
    var isOpen = false;
    var lastFocus = null;

    function focusables() {
      var list = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])');
      return Array.prototype.filter.call(list, function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close(true);
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      clearTimeout(timer);
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('rs-nl-lock');
      void root.offsetWidth; // apply the closed styles first so the fade-in runs
      root.classList.add('is-open');
      var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
      var input = root.querySelector('.rs-nl__input');
      var target = (input && !touch && !errorsEl) ? input : dialog;
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      document.addEventListener('keydown', onKey);
    }

    function close(snooze) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('rs-nl-lock');
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () { if (!isOpen) root.hidden = true; }, 260);
      if (snooze && !successEl) set(ls, K_SNOOZE, Date.now() + snoozeDays * DAY);
      if (lastFocus && lastFocus.focus) {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    function copyCode(btn) {
      var code = successEl && successEl.getAttribute('data-code');
      if (!code) return;
      function done() {
        btn.textContent = 'Copied';
        window.setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
      }
      function fallback() {
        var el = root.querySelector('.rs-nl__code-value');
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        try { if (document.execCommand('copy')) done(); } catch (e) {}
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else {
        fallback();
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-rs-nl-close]')) {
        e.preventDefault();
        close(true);
        return;
      }
      var copy = t.closest('[data-rs-nl-copy]');
      if (copy) {
        e.preventDefault();
        copyCode(copy);
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        set(ss, K_SENT, '1');
        var btn = form.querySelector('[type="submit"]');
        if (btn) {
          window.setTimeout(function () { btn.disabled = true; }, 0);
          window.setTimeout(function () { btn.disabled = false; }, 8000);
        }
      });
    }

    api.open = open;
    api.close = function () { close(false); };

    function shown(el) {
      var r = el.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) return false;
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0.05;
    }

    function busy() {
      if (document.hidden) return true;
      var html = document.documentElement;
      if (html.classList.contains('rs-booting')) return true;
      // Another pop-up (the ghost hunt alert) can ask for breathing room so the two never stack.
      if (Number(get(ss, 'rsPopupHold')) > Date.now()) return true;
      var layers = document.querySelectorAll('.drawer[aria-hidden="false"], .modal[aria-hidden="false"], .popover[aria-hidden="false"], [aria-modal="true"]');
      for (var i = 0; i < layers.length; i++) {
        if (!root.contains(layers[i]) && shown(layers[i])) return true;
      }
      var ae = document.activeElement;
      if (ae && ae !== document.body && !root.contains(ae) && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return true;
      return false;
    }

    function tryOpen() {
      if (get(ls, K_DONE) === '1') return;
      if (busy()) {
        timer = window.setTimeout(tryOpen, 4000);
        return;
      }
      open();
    }

    // 1. Coming back from a sign-up: show the code and add it to the cart.
    var posted = hasParam('customer_posted', 'true');
    var sent = get(ss, K_SENT) === '1';
    if (successEl && posted) {
      del(ss, K_SENT);
      set(ls, K_DONE, '1');
      applyCode(successEl.getAttribute('data-code'));
      cleanUrl();
      open();
      return;
    }
    // 2. Our sign-up came back with an error (e.g. an invalid email): reopen so it can be fixed.
    if (errorsEl && sent) {
      del(ss, K_SENT);
      cleanUrl();
      open();
      return;
    }
    // 3. Preview on demand.
    if (hasParam('rs_nl', '1')) {
      open();
      return;
    }
    // 4. Theme editor: open while the section is selected, never on a timer.
    if (window.Shopify && window.Shopify.designMode) return;
    // 5. Normal visit.
    if (cfg.subscribed || get(ls, K_DONE) === '1') return;
    var until = Number(get(ls, K_SNOOZE)) || 0;
    if (until > Date.now()) return;
    var start = Number(get(ss, K_START)) || 0;
    if (!start) {
      start = Date.now();
      set(ss, K_START, start);
    }
    var wait = Math.max(2000, delay - (Date.now() - start));
    clearTimeout(timer);
    timer = window.setTimeout(tryOpen, wait);
  }

  function boot() { init(document.querySelector('[data-rs-nl]')); }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-rs-nl]');
    if (root) init(root);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-rs-nl]')) api.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-rs-nl]')) api.close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();